import api from './axios';

export const login = (email, senha, manterConectado = true) =>
  api.post('/auth/login', { email, senha, manter_conectado: manterConectado });
export const getMe = () => api.get('/auth/me');
export const updateMe = (data) => api.patch('/auth/me', data);
export const esqueciSenha = (email) => api.post('/auth/esqueci-senha', { email });
export const redefinirSenha = (token, novaSenha) => api.post('/auth/redefinir-senha', { token, nova_senha: novaSenha });
